import React, { memo, useEffect, useState } from "react";
import Collapse from "@mui/material/Collapse";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import TableGrid from "./TableGridView/TableGrid";
import CommonPopper from "./Popper/CommonPopper";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Typography, Grid } from "@mui/material";
import classes from "../Pages/Approval/Investigation/Investigation.module.css";
import InvestigationAssignedBlock from "../Pages/Approval/Investigation/InvestigationAssignedBlock";
import { assignBlock } from "../constants/caseManagementData";
import useToaster from "../customHook/useToaster";
import CustomTooltip from "./CustomTooltip/CustomTooltip";
import { formatDateString, truncateMiddleText } from "../Utils/helper";
import TabelPopover from "./Popper/TabelPopover";
import VisibilityIcon from "@mui/icons-material/Visibility";
import _ from "lodash";
import { useSelector } from "react-redux";
import TableComponent from "./Table";

function TableRowComponent({
  StyledTableRow,
  row,
  rowIndex,
  columnsData,
  StyledTableCell,
  TableCollapseContent,
  TableCollapseContentDocument,
  open,
  setOpen,
  vendorDetailsTab,
  proposalCategoryTab,
  onClickFirstPopper = () => {},
  onCloseFirstPopper = () => {},
  onClickSecondPopper = () => {},
  onCloseSecondPopper = () => {},
  onCellClicked = () => {},
  unFlagApiClick = () => {},
  noOfPopper = 2,
  secondPopperListItem = [],
  popperContentMatch,
  isCreateCase = false,
  bgCellColor = "",
  boxShadow = "",
  stickyColumnName,
  isActiveStickyColumnBorder,
  isApproval = false,
  isDisabled = () => {},
  isNoData = false,
  isCheckbox = true,
  setIsUploadedInvoice = () => {},
  selectedColumnBackgroundColor = "white",
  firstTabVal,
  isStandardTable = false,
  openActionModal = false,
  actionPopperRef = {},
  flagToHideView = false,
  createCaseClickHandler = () => {},
  isCheckBoxTable = false,
  handleCheckboxClick = () => {},
  fromGlobalSearch = false,
}) {
  const navigate = useNavigate();
  const [openpop, setOpenPop] = useState(false);
  const [el, setEl] = useState(null);
  const [openActtionPopper, setOpenActtionPopper] = useState(false);
  const [actionEl, setActionEl] = useState(null);
  const maxWidth = useMediaQuery("(max-width:1140px)");
  const { showToast } = useToaster();
  const [rowNumber, setRowNumber] = React.useState(0);
  const [openModal, setOpenModal] = React.useState(false);
  const selectedIds = useSelector((state) => state.checkboxSlice.selectedIds);
  const isQcReviewRow = Object.values(row || {}).includes("qcReview");
  // const createCaseClickHandler = () => {
  //   navigate("/caseManagement");
  //   showToast("Coming Soon.", "info", true);
  // };
  const onCellClickedhandler = (
    e,
    colId,
    colValue,
    lobName,
    index,
    isHold,
    row
  ) => {
    if (isNoData) return;
    if (colValue === "View Details") {
      setOpen(index);
    } else if (colId === popperContentMatch) {
      setOpenPop(true);
      setEl(e.currentTarget);
    } else if (colValue === "Create Case") {
      return createCaseClickHandler();
    }
    onCellClicked(
      e,
      colId,
      colId === "case_id" ? row["case_id"] : colValue,
      lobName,
      index,
      isHold,
      row
    );
  };

  const categoryRowsWithSrNo = Array.isArray(TableCollapseContent)
    ? TableCollapseContent.map((item, index) => ({
        srNo: index + 1,
        ...item,
      }))
    : [];

  const onClickFirstPopperLocal = (e, type) => {
    if (type === "view") {
      setOpenPop(false);
    } else if (type === "viewInvoice") {
      setIsUploadedInvoice(true);
      setOpenPop(false);
    }
    onClickFirstPopper(
      e,
      type,
      row?.srNo,
      row?.case_id,
      row?.is_hold,
      row?.concludedat || row?.["Closure Date"],
      row?.claim_no,
      row
    );
  };
  // const onClickSecondPopperLocal = (e, type) => {
  //   onClickSecondPopper(e, type);
  // };
  // const onCloseSecondPopperLocal = (e) => {
  //   setOpenActtionPopper(false);
  //   onCloseSecondPopper(e);
  // };

  const getColumnValue = (column, value, valueWithTooltip) => {
    const getReopenSuffix = () => {
      const suffixes = [];
      if (row?.is_reopen) suffixes.push("RO");
      if (row?.is_hcs_reopen) suffixes.push("HCS");
      if (row?.is_dv_raised) suffixes.push("DV");
      return suffixes.length ? ` (${suffixes.join("/ ")})` : "";
    };

    if (column?.id === "case_id") {
      if (firstTabVal === "Hold" || firstTabVal === "Closed") {
        const claimNo = row["claim_no"] || "-";
        return row?.is_reopen || row?.is_hcs_reopen || row?.is_dv_raised ? `${claimNo}${getReopenSuffix()}` : claimNo;
      }
      return row["case_no"] || "-";
    }
    if (column?.id === "claim_no") {
      const claimNo = row["claim_no"] || "-";
      return row?.is_reopen || row?.is_hcs_reopen || row?.is_dv_raised ? `${claimNo}${getReopenSuffix()}` : claimNo;
    }
    if (column?.id === "claim_number") {
      const claimNumber = row["claim_number"] || "-";
      return row?.is_reopen || row?.is_hcs_reopen || row?.is_dv_raised ? `${claimNumber}${getReopenSuffix()}` : claimNumber;
    }
    //  logic ONLY for TAT column
    if (column?.id === "tat") {
      return value !== null && value !== undefined ? valueWithTooltip : "-";
    }
    // default behavior for all other columns
    return value ? valueWithTooltip : "-";
  };

  useEffect(() => {
    if (!openActionModal && actionPopperRef?.current?.caseId == row?.case_id) {
      let popperRef = document?.getElementById(
        `case_id_${actionPopperRef?.current?.caseId}`
      );
      setOpenPop(actionPopperRef?.current?.open || false);
      setEl(popperRef);
    }
  }, [actionPopperRef]);

  const openModalHandler = (rowvalue) => {
    setOpenModal(true);
    setRowNumber(rowvalue);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <StyledTableRow
        key={row?.srNo}
        sx={{
          backgroundColor: selectedColumnBackgroundColor,
          ...boxShadow,
          // boxShadow: boxShadow,
        }}
      >
        {columnsData?.map((column, index) => {
          const value =
            column?.id === "alert" && Array.isArray(row?.alert) ? (
              row?.is_hold ? (
                <div style={{ position: "relative" }}>
                  <span
                    style={{
                      // textDecoration: "underline",
                      // textDecorationColor: "#396AF2",
                      // color: "#396AF2",
                      cursor: "pointer",
                    }}
                    onClick={() => openModalHandler(index)}
                  >
                    <svg
                      width="18"
                      height="16"
                      viewBox="0 0 18 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
                        fill="#E42125"
                      />
                      <path
                        d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
                        fill="#FFFCF2"
                      />
                      <path
                        d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
                        fill="#FFFCF2"
                      />
                    </svg>
                  </span>
                  {openModal && rowNumber === index && (
                    <TabelPopover
                      openModal={openModal}
                      setOpenModal={setOpenModal}
                      handleClose={handleCloseModal}
                    >
                      {row?.alert?.map((item, index) => (
                        <div key={index}>
                          {Object.entries(item?.hold).map(([key, value]) => (
                            <div key={key} style={{ textAlign: "justify" }}>
                              <span
                                style={{
                                  fontWeight: "600",
                                  fontSize: "12px",
                                }}
                              >
                                {key.charAt(0).toUpperCase() +
                                  key.slice(1).replace(/_/g, " ")}
                                :- &#160;
                              </span>
                              <span style={{ fontSize: "12px" }}>{value}</span>
                            </div>
                          ))}
                        </div>
                      ))}
                    </TabelPopover>
                  )}
                </div>
              ) : null
            ) : (
              formatDateString(
                isNoData
                  ? row[0]
                  : column.id === "customer_segment" &&
                      column.label !== "Customer Type"
                    ? `${row.customer_segment ?? "-"} / ${row.policy_flag ?? "-"}`
                    : row[column.id]
              )
            );
          const valueAhead = row.create_case;
          const valueWithTooltip = (
            <CustomTooltip
              id={`${column?.id}-${row?.srNo}`}
              content={value}
              sx={{ fontSize: "1rem" }}
            />
          );
          return value === "View Blocks" ? (
            <StyledTableCell
              key={column.id}
              align={column.align ? column.align : "center"}
              ref={column.ref}
            >
              <span
                id={`${column?.id}_${value}`}
                ref={column.ref}
                style={{
                  backgroundColor: "#E42125",
                  color: "#fff",
                  padding: ".45rem 1.6rem",
                  borderRadius: "4px",
                  cursor: column.cursor,
                  display: "inline-block",
                  textAlign: "center",
                }}
                onClick={(e) =>
                  onCellClickedhandler(
                    e,
                    column?.id,
                    value,
                    row?.lob_name,
                    rowIndex,
                    row?.is_hold,
                    row
                  )
                }
              >
                {value}
              </span>
            </StyledTableCell>
          ) : value === "Hide Blocks" ? (
            <StyledTableCell
              key={column.id}
              align={column.align ? column.align : "center"}
              ref={column.ref}
              style={{
                borderBottom: open === rowIndex && vendorDetailsTab ? 0 : null,
              }}
            >
              <span
                id={`${column?.id}_${value}`}
                ref={column.ref}
                style={{
                  backgroundColor: "#fce7e7",
                  color: "#E42125",
                  border: "1px solid #E42125",
                  padding: ".45rem 1.6rem",
                  borderRadius: "4px",
                  cursor: column.cursor,
                }}
                onClick={(e) =>
                  onCellClickedhandler(
                    e,
                    column.id,
                    value,
                    row?.lob_name,
                    rowIndex,
                    row?.is_hold,
                    row
                  )
                }
              >
                {value}
              </span>
            </StyledTableCell>
          ) : ["Re-assign", "Withdraw"].includes(value) ? (
            <StyledTableCell
              key={column.id}
              align={column.align ? column.align : "center"}
              ref={column.ref}
            >
              {!isQcReviewRow && row?.case_status !== "approved" && (
                <span
                  style={{
                    background: "#F6F6F6",
                    border: "1px solid #B1B1B1",
                    borderRadius: "4px",
                    padding: "4px 8px",
                    cursor: column.cursor,
                    display: "inline-block",
                    textAlign: "center",
                  }}
                  onClick={(e) =>
                    onCellClickedhandler(
                      e,
                      column?.id,
                      value,
                      row?.lob_name,
                      rowIndex,
                      row?.is_hold,
                      row
                    )
                  }
                  onMouseEnter={(e) => {
                    let style = e.target.style;
                    style.backgroundColor = "#F6BFC1";
                    style.color = "#E42125";
                    style.border = "none";
                    style.boxShadow = "0px 4px 10px 0px #00000033";
                    style.border = "1px solid #F6BFC1";
                  }}
                  onMouseLeave={(e) => {
                    let style = e.target.style;
                    style.backgroundColor = "#F6F6F6";
                    style.border = "1px solid #B1B1B1";
                    style.borderRadius = "4px";
                    style.color = "black";
                    style.boxShadow = "none";
                  }}
                >
                  {value}
                </span>
              )}
            </StyledTableCell>
          ) : column?.id === "manual_trigger_remark" &&
            row?.lobName === "A&H" ? (
            <StyledTableCell
              key={column?.id}
              align={column?.align ? column?.align : "center"}
            >
              <span
                style={{
                  cursor: column.cursor,
                }}
                onClick={(e) =>
                  onCellClickedhandler(
                    e,
                    column?.id,
                    value,
                    row?.lobName,
                    rowIndex,
                    row?.is_hold,
                    row
                  )
                }
              >
                {<VisibilityIcon fontSize="large" />}
              </span>
            </StyledTableCell>
          ) : ["Review", "Reassigned"].includes(value) ? (
            <StyledTableCell
              key={column.id}
              align={column.align ? column.align : "center"}
              ref={column.ref}
              style={{
                borderBottom: open === rowIndex && vendorDetailsTab ? 0 : null,
              }}
            >
              <span
                ref={column.ref}
                style={{
                  backgroundColor: "#D6E0FE",
                  color: "#396AF2",
                  padding: ".8rem 1.65rem",
                  borderRadius: "4px",
                  display: "inline-block",
                  textAlign: "center",
                }}
              >
                {value}
              </span>
            </StyledTableCell>
          ) : value === "Pending" ? (
            <StyledTableCell
              key={column.id}
              align={column.align ? column.align : "center"}
              ref={column.ref}
              style={{
                borderBottom: open === rowIndex && vendorDetailsTab ? 0 : null,
              }}
            >
              <span
                ref={column.ref}
                style={{
                  backgroundColor: "#FFF2CD",
                  color: "#684E01",
                  padding: ".8rem 1.65rem",
                  borderRadius: "4px",
                  display: "inline-block",
                  textAlign: "center",
                }}
              >
                {value}
              </span>
            </StyledTableCell>
          ) : ["approved", "vendor-accepted"].includes(value) ? (
            <StyledTableCell
              key={column.id}
              align={column.align ? column.align : "center"}
              ref={column.ref}
              style={{
                borderBottom: open === rowIndex && vendorDetailsTab ? 0 : null,
              }}
            >
              <span
                ref={column.ref}
                style={{
                  backgroundColor: "#C5F5D9",
                  color: "#0C7436",
                  padding: ".8rem 1.2rem",
                  borderRadius: "4px",
                  display: "inline-block",
                  textAlign: "center",
                }}
              >
                {value}
              </span>
            </StyledTableCell>
          ) : value === "Rejected" ? (
            <StyledTableCell
              key={column.id}
              align={column.align ? column.align : "center"}
              ref={column.ref}
              style={{
                borderBottom: open === rowIndex && vendorDetailsTab ? 0 : null,
                background: bgCellColor,
              }}
            >
              <span
                ref={column.ref}
                style={{
                  backgroundColor: "#FFD6CC",
                  color: "#991F01",
                  padding: ".8rem 1.4rem",
                  borderRadius: "4px",
                  display: "inline-block",
                  textAlign: "center",
                }}
              >
                {value}
              </span>
            </StyledTableCell>
          ) : value === "qcReview" ? ( <StyledTableCell
              key={column.id}
              align={column.align ? column.align : "center"}
              ref={column.ref}
              style={{
                borderBottom: open === rowIndex && vendorDetailsTab ? 0 : null,
                background: bgCellColor,
              }}
            >
              <span
                ref={column.ref}
                style={{
                  backgroundColor: "#59ce8f",
                  color: "#fff",
                  padding: ".8rem 1.4rem",
                  borderRadius: "4px",
                  display: "inline-block",
                  textAlign: "center",
                }}
              >
                {value}
              </span>
            </StyledTableCell>
          ) : value === "View Details" && !valueAhead && open === rowIndex ? (
            <StyledTableCell
              key={"empty"}
              ref={column.ref}
              style={{
                backgroundColor: "#DB90A4",
              }}
            >
              <IconButton
                aria-label="previous page"
                sx={{
                  color: "#fff",
                  marginLeft: "1rem",
                  padding: "0px",
                }}
                onClick={() => setOpen((prev) => false)}
              >
                <KeyboardArrowUpIcon fontSize="large" />
              </IconButton>
            </StyledTableCell>
          ) : value === "View Details" && open === rowIndex ? (
            <StyledTableCell
              key={"empty2"}
              ref={column.ref}
              style={{
                backgroundColor: "#DB90A4",
              }}
            ></StyledTableCell>
          ) : value === "Create Case" && open === rowIndex ? (
            <StyledTableCell
              key={column.id}
              align={column.align ? column.align : "center"}
              ref={column.ref}
              style={{
                backgroundColor: "#DB90A4",
                color: "#fff",
                fontSize: column.fontSize,
                fontWeight: column.fontWeight,
                minWidth: column.minWidth,
                maxWidth: column.maxWidth,
                cursor: column.cursor,
              }}
            >
              <span
                ref={column.ref}
                style={{
                  backgroundColor: "#fff",
                  color: "#1395CC",
                  padding: ".1rem .9rem",
                  borderRadius: "50px",
                  display: "inline-block",
                  textAlign: "center",
                }}
                onClick={createCaseClickHandler}
              >
                {value}
              </span>
              <IconButton
                aria-label="previous page"
                sx={{
                  color: "#fff",
                  marginLeft: "1rem",
                  padding: "0px",
                }}
                onClick={() => setOpen((prev) => false)}
              >
                <KeyboardArrowUpIcon fontSize="large" />
              </IconButton>
            </StyledTableCell>
          ) : open === rowIndex && !vendorDetailsTab ? (
            <StyledTableCell
              key={column.id}
              align={column.align ? column.align : "center"}
              ref={column.ref}
              style={{
                backgroundColor: "#DB90A4",
                color: "#fff",
                fontSize: column.fontSize,
                fontWeight: column.fontWeight,
                minWidth: column.minWidth,
                maxWidth: column.maxWidth,
                cursor: column.cursor,
              }}
              onClick={
                value === "View Details" ? () => setOpen(rowIndex) : null
              }
            >
              {value || "-"}
            </StyledTableCell>
          ) : (
            <StyledTableCell
              data-sticky={column.id === stickyColumnName ? "true" : "false"}
              key={column.id}
              align={column.align ? column.align : "center"}
              ref={column.ref}
              style={{
                color: isStandardTable ? "none" : column.color,
                fontSize: column.fontSize,
                fontWeight: column.fontWeight,
                minWidth: column.minWidth,
                maxWidth: column.maxWidth,
                width: "max-content",
                wordWrap: "break-word",
                paddingLeft: column.headerPaddingLeft,
                paddingRight: column.headerPaddingRight,
                paddingTop: column.headerPaddingTop,
                paddingBottom: column.headerPaddingBottom,
                position: column?.id === stickyColumnName ? "sticky" : "",
                left: column?.id === stickyColumnName ? 0 : "",
                borderRight:
                  column?.id === stickyColumnName && isActiveStickyColumnBorder
                    ? "2px solid #E8E8E8"
                    : "",
                background: bgCellColor,
                borderBottom: open === rowIndex && vendorDetailsTab ? 0 : null,
              }}
            >
              <Box
                id={`${column?.id}_${value}`}
                sx={{
                  display: "inline-block",
                  padding: "0 1rem 0 0",
                  color: column?.color || "initial",
                  fontWeight: column?.fontWeight || "initial",
                  cursor: isStandardTable
                    ? "default"
                    : column?.cursor || "default",
                }}
                onClick={(e) =>
                  onCellClickedhandler(
                    e,
                    column?.id,
                    value,
                    row?.lob_name,
                    rowIndex,
                    row?.is_hold,
                    row
                  )
                }
              >
                <Box>
                  {column?.id === "srNo" && row.is_starred ? (
                    <div style={{ display: "flex" }}>
                      <svg
                        style={{ marginRight: "5px", cursor: "pointer" }}
                        onClick={() => unFlagApiClick(row?.case_id)}
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.97571 12.125C9.87575 12.1254 9.77716 12.1018 9.68821 12.0563L6.50071 10.3875L3.31321 12.0563C3.2097 12.1107 3.093 12.135 2.97638 12.1264C2.85975 12.1178 2.74788 12.0766 2.65347 12.0076C2.55907 11.9386 2.48592 11.8445 2.44234 11.736C2.39876 11.6275 2.3865 11.5089 2.40696 11.3938L3.03196 7.87501L0.456956 5.37501C0.376617 5.29483 0.319626 5.1943 0.292098 5.08419C0.264571 4.97408 0.267547 4.85855 0.300706 4.75001C0.336931 4.63893 0.403566 4.54023 0.49305 4.4651C0.582534 4.38998 0.691283 4.34145 0.806956 4.32501L4.36946 3.80626L5.93821 0.600005C5.98938 0.494336 6.06929 0.405219 6.16878 0.342864C6.26826 0.280509 6.3833 0.247437 6.50071 0.247437C6.61812 0.247437 6.73315 0.280509 6.83264 0.342864C6.93212 0.405219 7.01203 0.494336 7.06321 0.600005L8.65071 3.8L12.2132 4.31876C12.3289 4.3352 12.4376 4.38373 12.5271 4.45885C12.6166 4.53398 12.6832 4.63268 12.7195 4.74376C12.7526 4.8523 12.7556 4.96783 12.7281 5.07794C12.7005 5.18805 12.6435 5.28858 12.5632 5.36876L9.98821 7.86876L10.6132 11.3875C10.6355 11.5047 10.6238 11.6258 10.5795 11.7365C10.5352 11.8473 10.4602 11.943 10.3632 12.0125C10.25 12.0918 10.1138 12.1314 9.97571 12.125Z"
                          fill="#E8505B"
                        />
                      </svg>
                    </div>
                  ) : isCheckBoxTable && column?.id === "select" ? ( //deEmpanel-list-inputBox-render
                    <input
                      style={{
                        cursor: row?.hosp_against_case
                          ? "not-allowed"
                          : "pointer",
                        accentColor: "#E42125",
                      }}
                      id={row?.checkBoxID}
                      type="checkbox"
                      checked={
                        row?.hosp_against_case ||
                        selectedIds.includes(row?.checkBoxID)
                      }
                      onChange={handleCheckboxClick}
                      disabled={row?.hosp_against_case}
                    />
                  ) : (
                    getColumnValue(column, value, valueWithTooltip)
                  )}
                  {/* <span style={{ position: "relative" }}> */}

                  {/* </span> */}
                </Box>
              </Box>
            </StyledTableCell>
          );
        })}
      </StyledTableRow>

      {proposalCategoryTab &&
        open === rowIndex &&
        Array.isArray(TableCollapseContent) &&
        TableCollapseContent.length > 0 && (
          <StyledTableRow>
            <StyledTableCell colSpan={columnsData.length}>
              <div style={{ paddingLeft: "32px", paddingTop: "8px" }}>
                <TableComponent
                  rowsData={categoryRowsWithSrNo}
                  columnsData={[
                    {
                      id: "srNo",
                      label: "Sr No.",
                      minWidth: 80,
                      align: "left",
                    },
                    {
                      id: "category_name",
                      label: "Category Name",
                      minWidth: 160,
                      align: "left",
                    },
                    {
                      id: "test_name",
                      label: "Test Name",
                      minWidth: 140,
                      align: "left",
                    },
                    {
                      id: "test_description",
                      label: "Test Description",
                      minWidth: 220,
                      align: "left",
                    },
                    {
                      id: "investigations",
                      label: "Investigations",
                      minWidth: 150,
                      align: "left",
                    },
                  ]}
                  tablePagination={false}
                  stickyHeader={false}
                  hideBorders={false}
                  isNoDataRow={false}
                  columnHeaderBackgroundColor="#FFF3E0"
                  columnHeaderColor="#3A3A3A"
                  columnHeaderFont={12}
                  columnHeaderFontWeight={600}
                  columnBodyFont={11}
                  columnBodyFontWeight={400}
                  paddingLeftHeaderStyledTableCell="8px"
                  paddingBodyStyledTableCell="8px"
                  tablePadding="0"
                />
              </div>
            </StyledTableCell>
          </StyledTableRow>
        )}
      {open === rowIndex && !vendorDetailsTab && !proposalCategoryTab ? (
        <TableRow
          sx={{
            width: "100%",
          }}
        >
          <TableCell
            style={{
              padding: "0px",
              border: "1px solid #DB90A4",
              boxShadow: "0px 5px 25px rgba(0, 0, 0, 0.06)",
            }}
            colSpan={columnsData.length}
          >
            <Collapse
              in={open === rowIndex}
              timeout="auto"
              unmountOnExit
              sx={{}}
            >
              <TableGrid
                gridContent={TableCollapseContent}
                isDocument={!_.isEmpty(TableCollapseContent?.documents)}
                documentDetails={TableCollapseContent?.documents}
                backgroundColor="#FBF5FF"
                boxShadow="0px 0px 0px 0px"
                rowSpacing={0}
              />
            </Collapse>
          </TableCell>
        </TableRow>
      ) : open === rowIndex && vendorDetailsTab ? (
        <TableRow
          sx={{
            width: "100%",
          }}
        >
          <TableCell
            style={{
              padding: "0px",
            }}
            colSpan={columnsData.length}
          >
            <div>
              <Grid
                container
                spacing={2}
                sx={{ mt: "1.5rem", mb: "1rem", pl: "1.6rem" }}
              >
                <Grid item xs={4}>
                  <Typography
                    className={classes["investigators-tab-user-details-label"]}
                  >
                    Mobile No.:
                  </Typography>
                  <Typography
                    className={
                      classes["investigators-tab-user-details-content"]
                    }
                  >
                    {TableCollapseContent?.mobile_number}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography
                    className={classes["investigators-tab-user-details-label"]}
                  >
                    Location:
                  </Typography>
                  <Typography
                    className={
                      classes["investigators-tab-user-details-content"]
                    }
                  >
                    {TableCollapseContent?.location}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography
                    className={classes["investigators-tab-user-details-label"]}
                  >
                    Email ID:
                  </Typography>
                  <Typography
                    className={
                      classes["investigators-tab-user-details-content"]
                    }
                  >
                    {TableCollapseContent?.email}
                  </Typography>
                </Grid>
              </Grid>
            </div>
            <div
              className=""
              style={{
                padding: "20px",
              }}
            >
              <InvestigationAssignedBlock
                isCheckbox={isCheckbox}
                ApprovalInvestigationAssignedBlocks={assignBlock}
                InvestigationAssignedBlockClickHandler={() => {}}
                InvestigatorTabDetails={TableCollapseContent?.blocksAssigned?.map(
                  (item) => ({ id: item })
                )}
              />
            </div>
          </TableCell>
        </TableRow>
      ) : null}
      <CommonPopper
        open={isStandardTable ? false : openpop}
        anchorEl={el}
        onClick={onClickFirstPopperLocal}
        onClose={() => {
          actionPopperRef.current = null;
          setOpenPop(false);
          onCloseFirstPopper();
        }}
        width={maxWidth ? "10%" : isCreateCase ? "15.8%" : "16%"}
        sx={{ minWidth: "11.9rem", position: "absolute !important" }}
        isCreateCase={isCreateCase}
        actionList={secondPopperListItem}
        isHold={row?.is_hold}
        flagToHideView={flagToHideView}
        flagToViewAction={
          row?.flag ||
          (secondPopperListItem?.length === 0 && "false") ||
          (firstTabVal === "Recommended" ? "false" : "true")
        }
        actionExpanded={actionPopperRef?.current?.open || false}
      />
      {/* {noOfPopper === 2 && (
        <CommonPopper
          list={secondPopperListItem}
          isList={true}
          open={openActtionPopper}
          anchorEl={actionEl}
          onClick={onClickSecondPopperLocal}
          onClose={onCloseSecondPopperLocal}
          isApproval={isApproval}
          isDisabled={isDisabled}
        />
      )} */}
    </>
  );
}

export default memo(TableRowComponent);
